"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            backgroundColor: 'transparent',
            outline: 'none',
            border: 0,
            cursor: 'pointer',
            padding: 0,
            '&:focus-visible > svg': {
                backgroundColor: theme_1.default.colors.primaryLight,
                borderRadius: '50%',
            },
            '&:hover *': {
                fill: "".concat(theme_1.default.colors.primaryDark, " !important"),
            },
        },
    });
});
